import axios from "axios";
import { Cookies } from "react-cookie";
import { proxy } from "../config";
const cookie = new Cookies();

export const getGuideline = async (userType) => {
    const token = await cookie.get("token");
    return await axios.get(`${proxy}/guideline/user_type/${userType}`, {
        headers: { Authorization: token }
    });
};

export const addGuideline = async (formBack) => {
    const token = await cookie.get("token");
    return await axios.post(`${proxy}/guideline/create`, formBack, {
        headers: { Authorization: token }
    });
};

export const updateGuideline = async (id, name_en, name_ar, video) => {
    const token = await cookie.get("token");
    return await axios.put(`${proxy}/guideline/update/${id}`, {
        name_en: name_en,
        name_ar: name_ar,
        video: video
    }, {
        headers: { Authorization: token }
    });
};

export const deleteGuideline = async (id) => {
    const token = await cookie.get("token");
    return await axios.delete(`${proxy}/guideline/delete/${id}`, {
        headers: { Authorization: token }
    });
};